import pr1a from './pr1a.jpg'
import pr2a from './pr2a.jpg'
import pr3a from './pr3a.jpg'
import pr4a from './pr4a.jpg'


let all_product =[

     {
        id:13,
        name:"name4",
        category: "women",
        image: pr1a,
        new_price: 500,
        old_price:400
    },
    , {
        id:14,
        name:"name4",
        category: "women",
        image: pr2a,
        new_price: 500,
        old_price:400
    },
    , {
        id:15,
        name:"name4",
        category: "women",
        image: pr3a,
        new_price: 500,
        old_price:400
    },
     {
        id:16,
        name:"name4",
        category: "women",
        image: pr4a,
        new_price: 500,
        old_price:400
    }
]

export default all_product;